/**
 * Theme definitions for multi-version support.
 * Set REACT_APP_VERSION to "propify" or "adrec" in your .env file.
 */

export const THEMES = {
    propify: {
        name: "propify",
        cssVars: {
            "--primary": "#027BFF",
            "--bs-primary": "#797CFF",
            "--bs-secondary": "#999999",
            "--nav-active-color": "#ca10b8",
            "--nav-active-mobile-color": "#797CFF",
        },
        assets: {
            logo: "/img/propify/logo.svg",
            logoIcon: "/img/propify/favicon.svg",
            logoFooter: "/img/propify/logo.svg",
            favicon: "/img/propify/favicon.svg",
            logoFull: "/img/propify/logo-f.svg",
            platformLogo: "/img/propify/logo.svg",
            bidIcon: "/img/propify/bid-icon.svg",
            bidplaced: "/img/propify/bidplaced.svg",
            calendarPink: "/img/propify/calendar-pink.svg",
            checkP: "/img/propify/check-P.svg",
            checkWhiteHover: "/img/propify/check-white-hover.svg",
            checkboxCheck: "/img/propify/checkbox-check.svg",
            contactIcon: "/img/propify/contact-icon.svg",
            inspectionReport: "/img/propify/inspection-report.svg",
            radioIcon: "/img/propify/radio-icon.svg",
            reviewIcon: "/img/propify/review-Icon.svg",
            sendIcon: "/img/propify/send-icon.svg",
            tagIcon1: "/img/propify/tag-icon-1.svg",
            tagIcon3: "/img/propify/tag-icon-3.svg",
            valuationReport: "/img/propify/valuation-report.svg",
            adFullWidth: "/img/propify/ad-full-width.png",
            adFull: "/img/propify/ad-full.jpg",
            ad: "/img/propify/ad.png",
        },
    },
    adrec: {
        name: "adrec",
        cssVars: {
            "--primary": "#B8CEB1",
            "--bs-primary": "#B8CEB1",
            "--bs-secondary": "#ACA261",
            "--nav-active-color": "#A4C89A",
            "--nav-active-mobile-color": "#000000",
        },
        assets: {
            logo: "/img/adrec/logo.png",
            logoIcon: "/img/adrec/favicon.png",
            logoFooter: "/img/adrec/logo.png",
            favicon: "/img/adrec/favicon.png",
            logoFull: "/img/adrec/logo-f.png",
            platformLogo: "/img/adrec/adrec-logo.png",
            bidIcon: "/img/adrec/bid-icon.svg",
            bidplaced: "/img/adrec/bidplaced.svg",
            calendarPink: "/img/adrec/calendar-pink.svg",
            checkP: "/img/adrec/check-P.svg",
            checkWhiteHover: "/img/adrec/check-white-hover.svg",
            checkboxCheck: "/img/adrec/checkbox-check.svg",
            contactIcon: "/img/adrec/contact-icon.svg",
            inspectionReport: "/img/adrec/inspection-report.svg",
            radioIcon: "/img/adrec/radio-icon.svg",
            reviewIcon: "/img/adrec/review-Icon.svg",
            sendIcon: "/img/adrec/send-icon.svg",
            tagIcon1: "/img/adrec/tag-icon-1.svg",
            tagIcon3: "/img/adrec/tag-icon-3.svg",
            valuationReport: "/img/adrec/valuation-report.svg",
            adFullWidth: "/img/adrec/ad-full-width.png",
            adFull: "/img/adrec/ad-full.jpg",
            ad: "/img/adrec/ad.png",
        },
    },
};

const version = (process.env.REACT_APP_VERSION || "adrec").toLowerCase();
export const activeTheme = THEMES[version] || THEMES.adrec;
